import type { ReactNode } from "react";

import { styles } from "@repo/helpers";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../basic/card";

interface Props {
	title?: string;
	description?: string;

	version?: string;

	hideTlpLogo?: boolean;

	hideAppLogo?: boolean;
	appLogo?: string;

	hideBackgroundImage?: boolean;
	backgroundImage?: string;
	containerClass?: string;

	children: ReactNode;
}

export function LoginBackground(props: Props) {
	const {
		title,
		description,
		version,
		hideTlpLogo = false,
		hideAppLogo = false,
		appLogo,
		hideBackgroundImage = false,
		backgroundImage,
		containerClass,
		children,
	} = props;

	return (
		<div
			className={styles(
				"flex h-screen w-full flex-col items-center justify-center",
				hideBackgroundImage
					? "bg-white"
					: backgroundImage
						? `bg-[url(${backgroundImage})]`
						: `bg-[url(/images/Backgrounds/bkdg-default.jpg)]`,
				containerClass,
			)}
		>
			<div className="flex h-full w-full flex-col items-center justify-center">
				<AppLogo hide={hideAppLogo} logo={appLogo} />
				<Card className="mx-auto w-96 max-w-sm">
					<CardHeader>
						<CardTitle className="text-2xl">{title}</CardTitle>
						<CardDescription>{description}</CardDescription>
					</CardHeader>
					<CardContent>
						{children}
						{version !== undefined && (
							<span className="text-sm text-muted-foreground">Version: {version}</span>
						)}
					</CardContent>
				</Card>
			</div>
			<TlpLogo hide={hideTlpLogo} />
		</div>
	);
}

function AppLogo({ hide, logo }: { hide: boolean; logo?: string }) {
	if (hide) return null;
	return <img className="h-24" alt="TLP Cloud Logo" src={logo ?? "/Content/Logos/TLPLogo2.png"} />;
}

function TlpLogo({ hide }: { hide: boolean }) {
	if (hide) return null;
	return (
		<div className="flex h-48 w-full flex-col items-center justify-center">
			<h2 className="text-sm font-bold">Powered by</h2>
			<img className="h-24" alt="TLP Cloud Logo" src="/Content/Logos/TLPLogo2.png" />
		</div>
	);
}
